import React from 'react';

function ChatMessage({ message }) {
  const { type, content } = message;

  const getMessageStyle = () => {
    switch (type) {
      case 'user':
        return 'bg-gradient-to-r from-blue-600 to-purple-600 text-white ml-auto shadow-lg';
      case 'ai':
        return 'bg-white/90 backdrop-blur-sm text-gray-800 shadow-xl border border-white/20';
      case 'error':
        return 'bg-gradient-to-r from-red-500 to-pink-500 text-white border border-red-200';
      default:
        return 'bg-white/90 backdrop-blur-sm text-gray-800 shadow-xl border border-white/20';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'user':
        return '👤';
      case 'ai':
        return '🤖';
      case 'error':
        return '⚠️';
      default:
        return '💬';
    }
  };

  return (
    <div className={`flex ${type === 'user' ? 'justify-end' : 'justify-start'}`}>
      <div className={`max-w-2xl px-6 py-4 rounded-2xl shadow-lg ${getMessageStyle()}`}>
        <div className="flex items-center gap-3 mb-2">
          <span className="text-lg">{getIcon()}</span>
          <span className="text-sm font-semibold opacity-90">
            {type === 'user' ? 'You' : type === 'ai' ? 'AI Assistant' : 'Error'}
          </span>
        </div>
        <p className="text-base leading-relaxed">{content}</p>
      </div>
    </div>
  );
}

export default ChatMessage; 